import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

// helper function to trigger validation on all angular/forms fields in a
// group, including those with conditional validators that might not have
// been naturally triggered by the reactive forms system as the
// user moved through. This is intended to be used as a final check
// in the submit function before sending data to the server.
export function validateRecursive(control: AbstractControl) {
    if (control instanceof FormGroup) {
        const group = (control as FormGroup);

        for (const field in group.controls) {
            if (group.controls.hasOwnProperty(field)) {
                const c = group.controls[field];
                validateRecursive(c);
            }
        }
    } else if (control instanceof FormArray) {
        const group = (control as FormArray);

        for (const field in group.controls) {
            if (group.controls.hasOwnProperty(field)) {
                const c = group.controls[field];
                validateRecursive(c);
            }
        }
    }

    control.markAsTouched();
    control.updateValueAndValidity({onlySelf: false});
}
